var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompModal',{ref:"comp_modal",attrs:{"width":"400px"}},[_c('iframe',{staticStyle:{"display":"block"},attrs:{"src":_vm.src,"frameborder":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }